module.exports = __webpack_public_path__ + "img/title-bg.caaa02bd.png";